import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <FeaturesSection />
        <ContactSection />
        <CommentsSection />
        <RankingSection />
        <CardsSection />
        <FaqSection />
        <UpdatesSection />
        <CarouselSection />
        <TopicsSection />
        <AppSection />
        <IndexSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}